import { type ComponentType, type LazyExoticComponent, Suspense } from 'react'

export function PageLoader() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
    </div>
  )
}

/** lazy 페이지를 Suspense 로 감싼다 — 라우트 정의용. */
export function page<P extends object>(
  Component: LazyExoticComponent<ComponentType<P>>,
  props?: P,
) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component {...(props as P)} />
    </Suspense>
  )
}
